// shirleyProjectsConfig.js - קונפיגורציה מרכזית לפרויקטים של שירלי

export const shirleyProjectsConfig = [
  {
    id: 1,
    title: 'בית עתיק ציורי',
    subtitle: 'מושב אבן ספיר',
    category: 'אוריינטלי',
    folderName: 'בית עתיק ציורי במושב אבן ספיר',
    imageCount: 34,
    thumbnailIndex: 31,
    description: `בית ציורי עתיק בן כ-50 שנה שתוכנן במקור כקומפלקס דירות להשכרה.
היחידות אוחדו לכדי בית אחד גדול ומפנק למשפחה צעירה.
בתכנון השתמשתי בחומרים טבעיים שחלקם עברו שימוש חוזר, היה חשוב לי שאופי המבנה ישמר גם בפנים החלל.`
  },
  {
    id: 2,
    title: 'הבית בבית אריה',
    subtitle: 'עיצוב פנים מקיף',
    category: 'כפרי',
    folderName: 'הבית בבית אריה',
    imageCount: 11,
    thumbnailIndex: 6,
    description: ''
  },
  {
    id: 3,
    title: 'הבית האקלקטי',
    subtitle: 'של הודיה ועוזיה',
    category: 'אקלקטי',
    folderName: 'הבית האקלקטי של הודיה ועוזיה',
    imageCount: 31,
    thumbnailIndex: 1,
    description: `מדובר בבית פרטי שנבנה מאפס, 250 מ"ר בשתי קומות.
יחד עם בעלי הבית החלטנו לייצר מן ציר מרכזי שכל הבית סובב סביבו, תכננתי קיר קמין גבוה שחופה כולו באבן פראית ולצידו ספריית ברזל שמרככת ומעדנת את הדומיננטיות של האבן.
גם הקורות התקרתיות הן החלטה עיצובית ולא נגזרת של תכנון הגג, הקורות מעניקות לחלל איזה טוויסט וממסגרות את התקרה בצורה אלגנטית אך לא מתאמצת מידי.
זוג ההורים וששת ילדיהם מתאספים בחלל הזה בסוף כל יום.
הבית עוצב בסגנון אקלקטי, מאוד נקי מצד אחד אך עם מוטיבים כפריים וחמימים שיעניקו לחלל חום ולדיירים תחושה של בית חם, נעים ומזמין.
גם הבית הזה פורסם במגזין העיצוב PNIM`
  },
  {
    id: 4,
    title: 'הבית של דור ומוריה',
    subtitle: 'אורנית',
    category: 'מודרני עם טוויסט',
    folderName: 'הבית של דור ומוריה באורנית',
    imageCount: 32,
    thumbnailIndex: 4,
    description: `בית פרטי ב-2 קומות 200 מ"ר בישוב אורנית.
קונספט עיצובי מודרני משולב תעשייתי עם טוויסט של גוונים חמים.
הגוונים הדומיננטיים השתלבו בשלב הלבשת הבית.`
  },
  {
    id: 5,
    title: 'הבית של הילה',
    subtitle: 'ראשון לציון',
    category: 'מינימליסטי בצבעי פסטל',
    folderName: 'הבית של הילה מראשלצ',
    imageCount: 22,
    thumbnailIndex: 16,
    description: `מדובר בדירת 65 מ"ר בראשל"צ שהפכה מדירת 3 חדרים לדירת 4 חדרים.
היא פורסמה במגזין העיצוב PNIM - קראנו לה דירת הגלידה בגלל צבעי הפסטל שלה :-)
כל קירות הדירה נהרסו כליל ותכננתי את הבית בהתאם לצרכים של הלקוחה (חדר נוסף) ומטבח מפנק וגדול כיאה לחובבת בישול.
מוקד מיוחד בפרויקט הוא קיר קוביית הנגרות שמצד אחד עוטפת את המטבח ומצד שני משמשת מלא מקומות אחסון ודקורציה והשוס הוא דלת סתרים שנכנסים לחדר שירות מה שמשאיר את הבית נקי ומסודר.`
  },
  {
    id: 6,
    title: 'הבית של יוני וחדווי',
    subtitle: 'בית שמש',
    category: 'לופט תעשייתי ראסטי',
    folderName: 'הבית של יוני וחדווי בבית שמש',
    imageCount: 46,
    thumbnailIndex: 1,
    description: `בחוץ הבית עם ניחוחות ירושלמים, בפנים קיבל אופי תעשייתי חמים.
בית פרטי עם 2 קומות שקיבלתי במצב שלד ריק, הליווי כלל תכנון מלא של 2 הקומות ובחירות מלאות עד הפרט הקטן ביותר.
הקונספט העיצובי - בית ראסטי ומעט מחוספס אך חמים ומזמין.
חלל הסלון הגבוה (6 מ') ממש ביקש ליצור שם משהו אקסטרה שיכיל עוד מקום אחסון וכמובן יצור מוקד מעניין בחלל המרכזי.
תכננתי גלריית ברזל עם פרופיל שחור ומעט ראסטי ועליה ספריית ברזל שמכילה המון ספרים כיאה לאוהבי קריאה.
קיר הכח בסלון חופה בבריק מפירוק בגוון אדום והתגלה כהחלטה מדויקת שממש מקפיצה את החלל ומעניקה לו נראות של לופט ניו יורקי :-)`
  },
  {
    id: 7,
    title: 'הבית של רתם ואורטל',
    subtitle: 'באר גנים',
    category: 'מודרני',
    folderName: 'הבית של רתם ואורטל בבאר גנים',
    imageCount: 24,
    thumbnailIndex: 1,
    description: `מדובר בבית פרטי במושב באר גנים ששייך לזוג שמתגורר בהודו.
הליווי נעשה כמעט כולו בשלט רחוק - קיבלתי שלד ערום ותכננתי את הבית לפרטי פרטים עד הפריט הקטן ביותר.
בבית תקרה גבוהה וזה רק התבקש ליצור גלריה מעל המטבח שמצד אחד תקנה למטבח חמימות ומצד שני תייצר חלל גדול נוסף שכולו יועד לילדים.
בבית נבחרו חלונות ברזל דקיקים על מנת להכניס את החוץ פנימה.`
  },
  {
    id: 8,
    title: 'הבית של שיר וגלעד',
    subtitle: 'רמת גן',
    category: 'סקנדינבי',
    folderName: 'הבית של שיר וגלעד ברמת גן',
    imageCount: 25,
    thumbnailIndex: 9,
    description: `דירת קבלן למשתכן שבוצעו בה שינויים מבניים לאחר מסירה.
התבקשתי ליצור ים של מקומות אחסון... תוכנן קיר נגרות בסלון שמכיל המון ובתוכו מסתתרת דלת סתרים שדרכה נכנסים לקליניקה של בעלת הבית.
בעלת הבית היא קלינאית תקשורת שמקבלת בביתה לא מעט ילדים. בתכנון המקורי החדר היה ממש חשוף לסלון ובמחשבה משותפת החלטנו ל"העלימו" בעזרת קיר נגרות, מי שלא צריך לדעת - לא יודע שמסתתרת שם דלת :-)
הקליניקה והשירותי אורחים שלה תוכננו ועוצבו בעזרת נגרות עץ בירץ טבעי מתוך מחשבה ליצור משהו נטרלי שיאפשר כמה שפחות הסחות דעת לילדים המגיעים לטיפול.
יתר הבית תוכנן ועוצב בגוונים חמים ומרגיעים בסגנון אקלקטי.`
  },
  {
    id: 9,
    title: 'הדירה בדיזינגוף',
    subtitle: '55 מ"ר של קסם',
    category: 'תל אביבית קומפקטית',
    folderName: 'הדירה בדיזינגוף - 55 מ"ר',
    imageCount: 23,
    thumbnailIndex: 2,
    description: `מדובר בדירה של 55 מ"ר שנהרסה כליל כדי לייצר תכנון חכם.
תכננתי קיר נגרות ענק שמכיל את מזווה המטבח, דקורציה לסלון ו-2 דלתות סתרים שדרכם נכנסים לחדר שינה ולחדר רחצה.
מכיוון שהצורניות של הדירה צרה וארוכה תכננתי את סיומת הנגרות בפינה עגולה כדי לרכך את המעבר לאזור הציבורי של הבית.
הלקוחה חובבת ספרים מושבעת ולכן הוחלט לייצר קיר כח שמכיל יותר מ-200 ספרים ודווקא להדגיש אותו בעזרת רקע של בלוק חשוף, מה שמעניק לחלל אופי תל אביבי מעט ראסטי אך נקי בו זמנית.`
  },
  {
    id: 10,
    title: 'הפנטהאוז של שי ומיטל',
    subtitle: 'יוקרה בגובה',
    category: 'הפנטהאוז האקלקטי',
    folderName: 'הפנטהאוז של שי ומיטל',
    imageCount: 36,
    thumbnailIndex: 15,
    description: `תכנון דירת פנטהאוז קבלני בפ"ת - התכנון עבר טרנספורמציה והעמדה שונה לחלוטין.
אוחדו 2 חדרי שינה ליצירת סוויטת הורים גדולה ומפנקת.
הזוג הייטקיסטים שעובדים מהבית ולכן הוחלט ליצור משרד שהוא ממש גולת הכותרת, קירותיו נצבעו כקוביה בגוון חמרה והקירות הוסרו לגמרי, במקומם הותקן קיר זכוכית בפרופיל בלגי מדליק.
כחלק מהקונספט העיצובי והפרקטי בו זמנית הוחלט שקירות חדרי הרחצה לא יחופו בקרמיקה כלל אלא יבוצע בהם טיח רזינה שגם עמיד במים.`
  },
  {
    id: 11,
    title: 'מתחם ספא ואירוח',
    subtitle: 'חוויה מפנקת',
    category: 'מסחרי',
    folderName: 'מתחם ספא ואירוח',
    imageCount: 13,
    thumbnailIndex: 1,
    description: `במתחם הספא שהיה פעם מרתף גדול ולא מנוצל תוכננו 2 צימרים שעוצבו כל אחד מהם בקונספט שונה.
כל צימר קיבל בריכה גדולה, ג'קוזי וסאונה משלו...
מקום להיטען ולהנות...`
  }
];